import React from 'react';
import {useDropzone} from 'react-dropzone';
import { useCallback, useEffect, useState , createRef } from 'react';
import prettyBytes from 'pretty-bytes';
import { ReactComponent as IconUploadDocument} from '@/assets/svgs/document-upload.svg'
import Button from "@/components/Button/index";
import classname from 'classnames'
import { ReactComponent as IconTick } from '@/assets/svgs/tick.svg'

function EnrollmentDropzone({parentCallback, errorCallback, disabled, ...dropzoneOptions }) {

	const [files, setFiles] = useState([])
	const [error, setError] = useState("")

	const onDrop = useCallback(acceptedFiles => {
		setFiles(acceptedFiles.map(file => Object.assign(file,{
			preview:URL.createObjectURL(file)
		})))
	},[])

	const onDropRejected = useCallback(rejectedFiles => {
		return setError("File type must be doc and pdf.")
	}, [errorCallback]);

 	const { getRootProps, getInputProps, open } = useDropzone({ onDrop, onDropRejected, noClick:true, noDrag:true ,...dropzoneOptions })

	 const removeFile = (event) => {
		event.stopPropagation()
		setFiles([])
	}

	useEffect(() => {
		if (files.length > 0) {
			return parentCallback(files)
		}
		return parentCallback(false)
	}, [files])

	useEffect(() => {
		if (error.length > 0) {
			setFiles([])
			return errorCallback(error)
		}
		return errorCallback(false)
	}, [error])

	return (
	<div className="enrolment-request__upload-doc">

		<div {...getRootProps()} >
			<input {...getInputProps()} />
			{files.length === 0 && (
				<>
					<div className="enrolment-request__selection-container"><IconUploadDocument /></div>
					<Button full maxWidth="104" text="Upload Copy" submit={open} disabled={disabled}/>
					<div className='enrollmentDropZone__footnote'>Accepted file formate: <strong>.pdf</strong></div>
				</>
			)}
			{files.length > 0 && (
				files.map((file, index) => {
					return(
						<div className="enrollmentDropZone__preview-container"  key={index}>
							<div className="enrollmentDropZone__preview-icon"><IconUploadDocument /></div>
							<div className="enrollmentDropZone__preview-item">
								<div className="enrollmentDropZone__preview-item-name">{file.name}</div>
								<div className="enrollmentDropZone__preview-item-size">{`${prettyBytes(file.size).toUpperCase()}`}</div>
								<div className="enrollmentDropZone__preview-item-action">
									<div className="enrollmentDropZone__preview-item-replace" onClick={open}>Replace</div>
									<div className="enrollmentDropZone__preview-item-delete" onClick={removeFile}>Delete</div>
								</div>
							</div>
						</div>
					)


				})

			)}
		</div>

	</div>

	);
}

export default EnrollmentDropzone
